<template>
  <div>
    <NavTop ref="childRef" :parentData="this.$route.params.parentId" class="navbar"></NavTop>
<!--    <img src="https://file.yiqichuangying.com/media/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD%E5%9B%BE3.jpg" style="width: 100%;">-->
<!--    <div class="content">-->
<!--      <DetailedPage></DetailedPage>-->
<!--      <div class="title">-->
<!--        <div>{{newsList[0].authorName}}</div>-->
<!--        <div style="font-size: 15px;color: #cccccc;">MKS</div>-->
<!--      </div>-->
      <div class="whole">
        <!--        <DetailedPage :parentData="this.$route.params.parentId" :navigation="true" :tabBarData="this.$route.params.tabBarId"></DetailedPage>-->
        <DetailedPage :parentData="this.$route.params.parentId" :navigation="false" :tabBarData="this.$route.params.tabBarId"></DetailedPage>
        <div class="box">
          <div class="box_title">
<!--          <div class="box_title_l">{{ bigTitle }}</div>-->
            <div></div>
            <div class="box_title_r">
              <span @click="child">首页</span>
              <span>/{{ bigTitle }}</span>
            </div>
          </div>
          <div class="news" style="cursor: pointer" v-for="(item,index) in newsList" :key="index"
             @click="routerpushV('/basic/detail',item)">
          <div class="new_title">{{ item.title }}</div>
          <div class="new_date">{{ extractDate(item.publishTime) }}</div>
        </div>
<!--          <div class="news" style="cursor: pointer" v-for="(item,index) in newsList" :key="index"-->
<!--              @click="routerpushV('/basic/detail',item)" v-if="item.tabBarId == 491">-->
<!--            <div class="news_img">-->
<!--              <div></div>-->
<!--            </div>-->
<!--            <div class="news_date">-->
<!--              <div>-->
<!--                <div class="news_title">{{ item.title }}</div>-->
<!--                <div class="news_time"> {{ extractDate(item.publishTime) }}</div>-->
<!--              </div>-->
<!--              <div>-->
<!--                  <div class="news_buttom">详情</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div v-if="total > pageSize" style=" width: 100%;display: flex;justify-content: center;margin-bottom: 10px">
        <el-pagination @current-change="clickPage" :page-size="pageSize" background layout="prev, pager, next"
                     :total="total"/>
      </div>
    </div>
<!--  </div>-->
</template>

<script>
import home from '../../../../api/home.js'

export default {
  data () {
    return {
      // 每页数量
      pageSize: 15,
      // 总条数
      total: 0,
      // 大标题
      bigTitle: '',
      // 标题
      title: '学校首页新闻',
      // 二
      two: {
        to: '',
        text: '网站首页管理'
      },
      // 三
      three: {
        to: '',
        text: '/学校首页新闻'
      },
      // 列表数据
      newsList: [],
      // 携带参数
      xieDaiCanshu: ''
    }
  },
  created () {
    console.log(this.$route.params.tabBarId)
    // this.tabBarId = this.$route.params.tabBarId
    // if (this.$route.params.tabBarId == 491){
    //   this.pageSize = 5
    // }
    console.log(this.$route.params, 'llll')
    // 小导航
    this.getTabBar(this.$route.params.tabBarId)
    // 获取列表
    this.getList(this.$route.params.tabBarId, 1, this.pageSize)
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.tabBarId': function (newVal, oldVal) {
      // 在这里处理变化
      // 小导航
      this.getTabBar(newVal)
      // this.getList(newVal, 1, this.pageSize)

      window.location.reload()
    }
  },
  methods: {
    // 获取导航栏
    async getTabBar (id) {
      try {
        const res = await home.getTarBarInfo({id})
        this.bigTitle = res.data[0].name
        // console.log(res.data)
      } catch (e) {
        console.log(e)
      }
    },
    // 点击分页
    clickPage (e) {
      this.getList(this.$route.params.tabBarId, e, this.pageSize)
    },
    // 参数
    // quCanshu (url) {
    //   // 使用正则表达式匹配并提取路径中的动态数据部分
    //   var match = url.match(/\/(\d+)\/(\d+)/)
    //   if (match) {
    //     var dynamicData = match[0] // "/53/145"
    //     return dynamicData
    //   } else {
    //     console.log('No dynamic data found.')
    //   }
    // },
    // 查询文章列表
    async getList (tabBarId, pageNum, pageSize) {
      try {
        const res = await home.getWenZhang({tabBarId, pageNum, pageSize})
        this.newsList = res.rows
        this.total = res.total
        console.log(res)
      } catch (e) {
        console.log(e)
      }
    },
    // 跳转
    navigateTo (path, text) {
      console.log(path, text)
      if (text) {
        if (text == '网站首页管理') {
          this.$router.push(path + '/' + 0)
          this.title = '网站首页管理'
          this.two.text = '河北东方学院'
          this.three.text = '/网站首页管理'
          return
        }
        if (text == '河北东方学院') {
          this.$router.push(path + '/' + 1)
          this.title = '河北东方学院'
          this.two.text = ''
          this.three.text = '河北东方学院'
          return
        }
      }
      this.$router.push(path)
    },
    extractDate (dateTimeStr) {
      // 检查dateTimeStr是否为null或undefined
      if (!dateTimeStr) {
        console.log('dateTimeStr is null or undefined')
        return '' // 或者返回一个默认值，或者处理错误
      }
      // 假设日期时间格式总是 "YYYY-MM-DD HH:MM:SS"
      // 使用 split 方法按空格分割日期和时间
      const [date, time] = dateTimeStr.split(' ')
      // 返回日期部分
      return date
    },
    // 子组件方法
    child () {
      this.$refs.childRef.erJi();
    },
    // 跳转
    routerpush (path) {
      this.$router.push(path)
    },
    // 跳转
    routerpushV (path, item) {
      this.$router.push({path: path + '/' + this.$route.params.parentId + '/' + item.tabBarId + '/' + item.id})
    }
  }
}
</script>
<style lang="less" scoped>
.nav:hover {
  background-color: #9E070E;
}

.news {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
  padding-top: 10px;

  .new_title {
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #444;
    cursor: pointer;

    &:hover {
      color: #9E070E;
    }
  }
  .news_img {
    width: 40%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #444;
    cursor: pointer;
    border: 1px solid #f00;
    height: 240px;
    &:hover {
      color: #9E070E;
    }
  }
  .new_date {
    width: 20%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    text-align: right;
    color: #444;
  }
  .news_date {
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    //text-align: right;
    color: #444;
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .news_title{
      margin: 0px 0 20px;
      font-size: 20px;
    }
    .news_time{
      color: #cccccc;
    }
    .news_buttom{
      background-color: #c9151e;
      color: #fff;
      display: inline-block;
      padding: 5px 25px;
      border-radius: 50px;
    }
  }
}

.news:hover {
  color: #9e070e;
}
.content{
  width: 1200px;
  margin: 0 auto 0;
  position: relative;
  top: -80px;
  border-top: 6px solid #e60012;
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 40px 20px;
  box-shadow: 0px 0px 20px rgba(150, 150, 150, 0.5);

  .title{
    line-height: 36px;
    text-align: center;
    font-size: 22px;
  }
}


.whole {
  width: 1200px;
  margin: 0 auto 0;
  display: flex;
  justify-content: space-between;
  //z-index: 1;

}

.box {
  width: 960px;
  padding-top: 50px;
}

.box_title {
  width: 960px;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;

  .box_title_l {
    padding: 0 15px;
    line-height: 45px;
    font-size: 20px;
    font-weight: bold;
    color: #444;
    border-bottom: 2px solid #9e070e;
  }

  .box_title_r {
    font-size: 14px;
    color: #666;

    span {
      &:nth-child(1) {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .title_r_span1 {
      cursor: pointer;
      color: #666;

      &:hover {
        text-decoration: underline;
      }
    }

    .title_r_span2 {
      cursor: pointer;
      color: #666;

      &:hover {
        text-decoration: underline;
      }
    }

    .title_r_span3 {
      cursor: pointer;
      color: #666;
    }
  }
}
</style>
<style lang="less">
.el-pager {
  .number:hover {
    background-color: #8D080E !important;
    color: #fff !important;
  }
}

.active {
  background-color: #8D080E !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/common/section/more/more.vue